import React from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {

    }
}));

const CustomTextField = ({ label, placeholder, value, helperText, error, variant, style, addClass, handleChange }) => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <TextField
                style={style}
                id="outlined-helperText"
                label={label}
                placeholder={placeholder}
                value={value}
                error={error}
                helperText={helperText}
                variant={variant || "outlined"}
                onChange={(e) => handleChange(e.target.value)}
            />
        </div>
    )
}

export default CustomTextField